import { Dto, DtoWithId } from "@mango/core";
import { Artikel } from "./artikel";
import { Projectregel } from "./projectregel";
import { Relatie } from "./relatie";


@Dto({fullName: "CIJBorculo.Logic.ProjectregelArtikel"})
export class ProjectregelArtikel extends DtoWithId {
	projectregel: Projectregel;
	artikel: Artikel;
	aantal: number;
	aantal_Offerte: number;
	aantal_Besteld: number;
	aantal_Geleverd: number;
	prijs: number;
	inkoop: boolean;
}